import React, { ChangeEvent, useState } from 'react';
import { fetchData } from '../../_lib/lib';
import { isEmail } from '../../_lib/utils';
import apiToUrlMap from '../../ApiMapping';
import { BackButton, PrimaryButton, TextField } from '../../components/AtomComponents';
import LoadingDialog from '../../components/LoadingDialog/LoadingDialog';
import useDataService from '../../hooks/useDataService';
import { eMessageType } from '../../types/IMessageType';
import { useConfirm } from '../../context/ConfirmContext';

const SupressionList = () => {
  const { confirm } = useConfirm();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [isValidEmail, setIsValidEmail] = useState(false);
  const { openSnackBar } = useDataService();

  const checkSupressionList = async () => {
    setLoading(true);
    const res: any = await fetchData('POST', apiToUrlMap.checkSupressionList, {
      body: { email },
    });
    if (!res.suppressed) {
      openSnackBar(res.message, eMessageType.error);
    } else {
      openSnackBar(res.message, eMessageType.success);
    }
    setLoading(false);
  };

  const removeFromSupressionList = async () => {
    setLoading(true);
    const res: any = await fetchData('POST', apiToUrlMap.removeSupressionList, {
      body: { email },
    });
    if (!res.suppressed) {
      openSnackBar(res.message, eMessageType.error);
    } else {
      openSnackBar(res.message, eMessageType.success);
    }
    setLoading(false);
  };

  const handleEmailChange = (e: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const value = e.target.value.trim();
    setEmail(value);
    setIsValidEmail(isEmail(value));
  };

  return (
    <>
      <LoadingDialog isDialogOpen={loading} />
      <div className="cell small-6 medium-6 px-one-line-data margin-bottom-2">
        <BackButton />
        <h3 className="small-12 margin-bottom-1">Suppression List</h3>
      </div>
      <TextField
        label="Tenant Email"
        size="small"
        value={email}
        error={!isValidEmail}
        onChange={handleEmailChange}
        placeholder="Tenant Email"
        className="margin-right-1"
      />
      <PrimaryButton
        onClick={checkSupressionList}
        disabled={!isValidEmail}
        className="margin-right-1">
        CHECK
      </PrimaryButton>
      <PrimaryButton
        onClick={() => {
          confirm({
            onConfirm: removeFromSupressionList,
          });
        }}
        disabled={!isValidEmail}
      >
        REMOVE
      </PrimaryButton>
    </>
  );
};

export default SupressionList;
